module.exports = __webpack_public_path__ + "img/solidworks-logo.d6effa9a.png";